import { render, staticRenderFns } from "./QuickSupportCommandAdd.vue?vue&type=template&id=8f4ebe8e&scoped=true&"
import script from "./QuickSupportCommandAdd.vue?vue&type=script&lang=js&"
export * from "./QuickSupportCommandAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuickSupportCommandAdd.vue?vue&type=style&index=0&id=8f4ebe8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4ebe8e",
  null
  
)

export default component.exports